import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactLoading from 'react-loading'
import { removeSupplier, closeRemoveSupplierToLandModal } from 'redux/actions/lands'

const RemoveSupplierModal = ({ isOpen, closeModal, form, removeSupplier, isLoading }) => !form || !form.land || !form.supplier ? null : (
  <Modal isOpen={isOpen} fade={false} toggle={closeModal} className="warning">
    <ModalHeader toggle={closeModal}>Eliminar Proveedor de Lote</ModalHeader>
    <ModalBody>
      Estás seguro de que quieres borrar al proveedor {form.supplier.alias} de este lote ?
    </ModalBody>
    <ModalFooter>
      <Button disabled={isLoading} color="warning" className="mr-1" onClick={() => removeSupplier({ land: form.land, supplier: form.supplier.id })}>
        {isLoading && <ReactLoading type="spinningBubbles" color="#fff" height={10} width={10} className="d-inline-block mr-4 ml-2" />}
        Eliminar
      </Button>
      <Button disabled={isLoading} color="primary" onClick={closeModal}>Cancelar</Button>
    </ModalFooter>
  </Modal>
)

RemoveSupplierModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  form: PropTypes.shape({
    land: PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ])
      }),
      PropTypes.number
    ]),
    supplier: PropTypes.oneOfType([
      PropTypes.shape({
        alias: PropTypes.string,
        id: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
      }),
      PropTypes.number
    ]),
  }),
  closeModal: PropTypes.func.isRequired,
  removeSupplier: PropTypes.func.isRequired,
}

const mapStateToProps = ({ lands: { openedRemoveSupplierModal, supplierForm, removingSupplier }}) => ({
  isOpen: openedRemoveSupplierModal,
  form: supplierForm,
  isLoading: removingSupplier
})

const mapDispatchToProps = dispatch => ({
  removeSupplier: info => dispatch(removeSupplier(info)),
  closeModal: () => dispatch(closeRemoveSupplierToLandModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RemoveSupplierModal))
